import React from 'react';
import cx from 'classnames';
import { string, node, bool, func } from 'prop-types';

import PlusIcon from 'icons/plus.inline.svg';
import styles from './ListItem.scss';

const ListItem = ({ id, className, children, isActive, onClick, onMouseOver, onMouseOut }) =>
  <li
    className={cx(styles.main, className, {
      [styles.isActive]: isActive,
    })}
  >
    <a
      className={styles.link}
      href={`/map/create/segment/${id}`} // we dont' have offline urls for this
      onClick={evt => {
        evt.preventDefault();
        onClick();
      }}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
    >
      <span>
        {children}
      </span>
      <span className={styles.plus}>
        <PlusIcon className={styles.plusIcon} />
      </span>
    </a>
  </li>;

ListItem.propTypes = {
  id: string.isRequired,
  className: string,
  children: node,
  isActive: bool,
  onClick: func.isRequired,
  onMouseOver: func.isRequired,
  onMouseOut: func.isRequired,
};

export default ListItem;



// WEBPACK FOOTER //
// ./src/components/MapPanel/ListItem/index.js